import { type PropsWithChildren } from 'react';

/**
 * @public
 */
export type SelectV2CustomTriggerProps = PropsWithChildren;

/**
 * @public
 */
export function SelectV2CustomTrigger(props: SelectV2CustomTriggerProps): null {
  return null;
}
